import {
  DispositionType,
  PreparationOrder,
  PreparationOrderStatus,
} from "$types";
import { UserRoles } from "$utils/typeConstants/User";

export enum PreparationOrderErrors {
  OP_NOT_FOUND = "OP introuvable",
  OP_REF_PREPARATION_NOT_FOUND = "La référence préparation entrepôt doit être renseignée pour chaque OP du dossier. Veuillez les compléter.",
}

export const PREPARATION_ORDER_STATUS_LABELS: {
  [key in UserRoles]: { [key in PreparationOrderStatus]: string };
} = {
  [UserRoles.ADMIN]: {
    [PreparationOrderStatus.CREATED]: "A lancer",
    [PreparationOrderStatus.IN_PROGRESS]: "En cours",
    [PreparationOrderStatus.PREPARED]: "Préparé",
    [PreparationOrderStatus.TO_SHIP]: "A expédier",
    [PreparationOrderStatus.SHIPPED]: "Expédié",
    [PreparationOrderStatus.DELIVERED]: "Livré",
    [PreparationOrderStatus.COLLECTED]: "Collecté",
    [PreparationOrderStatus.CANCELLED]: "Annulé",
  },
  [UserRoles.USER]: {
    [PreparationOrderStatus.CREATED]: "En attente",
    [PreparationOrderStatus.IN_PROGRESS]: "En préparation",
    [PreparationOrderStatus.PREPARED]: "Préparation dispo",
    [PreparationOrderStatus.TO_SHIP]: "A expédier",
    [PreparationOrderStatus.SHIPPED]: "En expédition",
    [PreparationOrderStatus.DELIVERED]: "Livré",
    [PreparationOrderStatus.COLLECTED]: "Collecté",
    [PreparationOrderStatus.CANCELLED]: "Annulé",
  },
};

export const getPreparationOrderStatusLabelByRole = (
  userRole: UserRoles,
  opStatus: PreparationOrderStatus
): string => PREPARATION_ORDER_STATUS_LABELS[userRole][opStatus] || "";

export const getPreparationOrderStatusOptions = (userRole: UserRoles) => {
  const labels = PREPARATION_ORDER_STATUS_LABELS[userRole];
  const options = [];
  Object.keys(labels).forEach((status) => {
    options.push({
      value: status,
      label: labels[status],
    });
  });
  // No sort, keep the initial order
  // options.sort((a1, a2) => a1.label.localeCompare(a2.label));
  return options;
};

export const getShippingLocationLabel = (op: PreparationOrder): string =>
  `  ${op.entrepot.name ?? ""} ${op.entrepot.location.cp} ${
    op.entrepot.location.city
  }`;

export const getShippingLocationNote = (op: PreparationOrder): string =>
  op.entrepot.notes;

export const getDeliveryLocationLabel = (op: PreparationOrder): string =>
  op.shipType === DispositionType.ON_DOCKYARD
    ? `CHANTIER ${op.shipPostalCode ?? ""} ${op.shipCity ?? ""}`
    : op.shipType === DispositionType.OTHER_PLACE
      ? `${op.shipPlace} ${op.shipPostalCode} ${op.shipCity}`
      : `${op.shipEntrepotName} ${op.shipPostalCode} ${op.shipCity}`;

export const getDeliveryLocationLabelAlt = (op: PreparationOrder): string =>
  op?.shipType === DispositionType.ON_DOCKYARD
    ? `${op.dockyard.name} ${op.dockyard.code} ${op?.chantier.code} ${op?.chantier.name} ${op?.shipPostalCode} ${op?.shipCity}`
    : op?.shipType === DispositionType.OTHER_PLACE
      ? `${op?.shipPlace} ${op?.shipPostalCode} ${op?.shipCity}`
      : `${op?.shipEntrepotName} ${op?.shipPostalCode} ${op?.shipCity}`;
